import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';
import { Shield, LogIn } from 'lucide-react';

export default function FiscalLoginPage() {
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!login || !password) return toast.error('Preencha login e senha');
    setLoading(true);
    try {
      const res = await api.post('/fiscais/login', { login, password });
      localStorage.setItem('fiscal_token', res.data.token);
      localStorage.setItem('fiscal_data', JSON.stringify(res.data.fiscal));
      toast.success(`Bem-vindo, ${res.data.fiscal.name}!`);
      navigate('/fiscal');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao fazer login');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#001a33] to-[#003366] flex items-center justify-center p-4" data-testid="fiscal-login-page">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center pb-2">
          <div className="mx-auto w-16 h-16 bg-[#003366] rounded-full flex items-center justify-center mb-3">
            <Shield size={32} className="text-white" />
          </div>
          <CardTitle className="text-xl font-bold text-[#003366]">FISCAL DE ABASTECIMENTO</CardTitle>
          <p className="text-sm text-gray-500">Prefeitura Municipal de Carauari</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label>Login</Label>
              <Input value={login} onChange={e => setLogin(e.target.value)} placeholder="Seu usuario" required data-testid="fiscal-login-input" />
            </div>
            <div>
              <Label>Senha</Label>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Sua senha" required data-testid="fiscal-password-input" />
            </div>
            <Button type="submit" className="w-full bg-[#003366] hover:bg-[#1E3A5F]" disabled={loading} data-testid="fiscal-login-submit">
              <LogIn size={16} className="mr-2" /> {loading ? 'ENTRANDO...' : 'ENTRAR'}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <a href="/login" className="text-xs text-blue-600 hover:underline">Acessar como Administrador</a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
